import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "In 2020, what is \"frontend\" 🤨",
  "description": "",
  "published": "2020-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/in-2020-what-is-frontend/swizec/9470"],
  "categories": "Back End, Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1596818805047.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`"He's a frontend guy, is this even a fair question to ask?"`}</em></p>
    <p>{`The head of engineering was worried about our systems design question. Part of the standard process:`}</p>
    <ul>
      <li parentName="ul">{`test algorithms`}</li>
      <li parentName="ul">{`ask about systems`}</li>
      <li parentName="ul">{`pair program on a skills-based test`}</li>
      <li parentName="ul">{`culture`}</li>
    </ul>
    <p>{`I went through this in June. The algorithms question destroyed me and I thought about it for days 😅`}</p>
    <p>{`The systems design question was fun though.`}</p>
    <p>{`You design a social network newsfeed thingy. How would you store data? Which servers to use? What about caching? Where's the SQL? Schema design? Querying? Security?`}</p>
    <p><img parentName="p" {...{
        "src": "/4de6fec9780bb1546110741fe9beaedf/media-26BGIqWh2R1fi6JDa-giphy.gif",
        "alt": "computers giphy"
      }}></img></p>
    <p>{`Fair question if that's the work. Everyone's been doing everything. Small team.`}</p>
    <p>{`But will that stay true? Would you ask that question of someone who spent the last N years in a big company writing client JavaScript? 🤔`}</p>
    <h2 {...{
      "id": "frontend-vs-backend"
    }}>{`Frontend vs. Backend`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1291495546557931520"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.22869955156951%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'253\\'%20viewBox=\\'0%200%20400%20253\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%207c-4%201-10%207-11%2012-5%2015%2012%2029%2026%2021%205-3%205-4%201-5-4%200-5-2-3-5%201-1%202-2%205-2l3-1%202-1%201-3C46%2013%2033%204%2022%207m358%203c0%202-2%203-5%202l-3-2v3l2%205c1%202%201%202-1%203-1%201-1%201%203%201%205%200%2010-4%2010-7l1-4c0-1%200-2-3-2l-4%201M110%20153\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/195999e07288751e39a509fe67a27d7e/ca0a1/techletter.app-screenshot-1596818805047.webp 223w", "/static/195999e07288751e39a509fe67a27d7e/75680/techletter.app-screenshot-1596818805047.webp 445w", "/static/195999e07288751e39a509fe67a27d7e/8d1ba/techletter.app-screenshot-1596818805047.webp 890w", "/static/195999e07288751e39a509fe67a27d7e/7f3f2/techletter.app-screenshot-1596818805047.webp 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/195999e07288751e39a509fe67a27d7e/e92b6/techletter.app-screenshot-1596818805047.png 223w", "/static/195999e07288751e39a509fe67a27d7e/e66bf/techletter.app-screenshot-1596818805047.png 445w", "/static/195999e07288751e39a509fe67a27d7e/4ef49/techletter.app-screenshot-1596818805047.png 890w", "/static/195999e07288751e39a509fe67a27d7e/8ae78/techletter.app-screenshot-1596818805047.png 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/195999e07288751e39a509fe67a27d7e/4ef49/techletter.app-screenshot-1596818805047.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Growing up in the early 2000's, there was no frontend and backend.`}</p>
    <p>{`You write PHP? Okay you're a web developer.`}</p>
    <p>{`You write HTML? Yep, web developer.`}</p>
    <p>{`You write CSS? Yep, web developer.`}</p>
    <p>{`You do everything. Designer makes pretty pictures. You turn them into websites.`}</p>
    <p>{`Code runs on the server, cobbles together HTML and CSS, inserts dynamic data, spits out a webpage. Browser renders and deals with user interaction. Anything a user clicks is a new request to the server and a full page reload.`}</p>
    <p>{`Around 2010 the industry decided this was a bad idea. JavaScript apps were born.`}</p>
    <p>{`We now had frontend and backend.`}</p>
    <p><strong parentName="p">{`Backend engineers wrote server code`}</strong>{`. They designed data models, handled API requests, dealt with servers and hosting and REST design.`}</p>
    <p><strong parentName="p">{`Frontend engineers wrote the UI`}</strong>{`. Build the HTML, fuss over CSS, write JavaScript for interactive widgets, sometimes call an API.`}</p>
    <p>{`The work was visual in nature. Main goal was creating a nice user experience and offloading business logic to the server.`}</p>
    <h2 {...{
      "id": "frontend-infrastructure-vs-ui"
    }}>{`Frontend Infrastructure vs. UI`}</h2>
    <p>{`As JavaScript apps became more complex the frontend world developed a split 👉 infrastructure vs. UI.`}</p>
    <p>{`You build a design system and there's no UI work left.`}</p>
    <p>{`Design system ensures everything looks great. It's got a whole team. They write the CSS, the core design atoms, and self-contained interactive components.`}</p>
    <p>{`You don't think `}<em parentName="p">{`"Hm, how do I make a date widget?"`}</em>{` or `}<em parentName="p">{`"I wonder how to add this animation and pleasant interaction on the type-ahead field"`}</em></p>
    <p>{`Heck no!`}</p>
    <p>{`You slap a `}<inlineCode parentName="p">{`<DateInput />`}</inlineCode>{` or a `}<inlineCode parentName="p">{`<Input typeahead={true} />`}</inlineCode>{` in there and move on. 💪`}</p>
    <p>{`What you're left with is the `}<strong parentName="p">{`frontend infrastructure work`}</strong>{`.`}</p>
    <p>{`How do you design the data models? Where do the API calls go? How do you cache requests? How do you architect your app for speed `}<em parentName="p">{`and`}</em>{` good developer experience? How does a widget bottom-left get state from top-right?`}</p>
    <p>{`Sound familiar eh 🤔`}</p>
    <h2 {...{
      "id": "backend-of-the-frontend-vs-deep-backend"
    }}>{`Backend of the Frontend vs. Deep Backend`}</h2>
    <p>{`You create a backend of the frontend.`}</p>
    <p>{`The data layer that handles business logic, talks to the API, handles performance, and tells your UI layer how to act.`}</p>
    <p>{`You can go days, weeks, entire projects, without touching UI code. But you're working on the frontend. Writing JavaScript that runs in the browser.`}</p>
    <p>{`🤯`}</p>
    <p>{`Then you run this code on the server to create server-side rendering. Or on your own machine at deploy-time to create compiled JAMStack sites.`}</p>
    <p><img parentName="p" {...{
        "src": "/ffc0ec3def620c9a38ce2f700c72864a/media-aZ3LDBs1ExsE8-giphy.gif",
        "alt": "wtf giphy"
      }}></img></p>
    <p>{`What gives? Where's the backend?`}</p>
    <p>{`The `}<em parentName="p">{`true`}</em>{` backend is no longer your data model and your business logic. It's that API you're calling.`}</p>
    <p><em parentName="p">{`You`}</em>{` treat the API as backend developers of old treated their database. GraphQL makes this even more obvious.`}</p>
    <p>{`But `}<em parentName="p">{`somebody`}</em>{` builds that API. Makes it work. Makes it talk to other services. Ensures data's consistent. Deals with caching at scale.`}</p>
    <p>{`That's `}<strong parentName="p">{`The Deep Backend`}</strong>{`. The folks who live their lives in data pipelines, JSON validations, API schemas, databases, and server monitoring software.`}</p>
    <p>{`It's hard work. Mind-bending work. Plagued with `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev/robust-backend-design"
      }}>{`fundamental Two General paradoxes`}</a>{`.`}</p>
    <p>{`Imagine if Redux or useState had a 1% failure rate. 1% chance that you call an action and nothing happens. Oops.`}</p>
    <p>{`That's Deep Backend work.`}</p>
    <h2 {...{
      "id": "devops"
    }}>{`DevOps`}</h2>
    <p>{`DevOps is an area tangential to Deep Backend. Maybe orthogonal? 🤔`}</p>
    <p>{`The part that deals with servers and hosting. Used to be part of backend work.`}</p>
    <p>{`You provision a server, create a database, run scripts on the command line, write kubernetes configurations, and think about Docker and containers. Sometimes you play with the AWS console.`}</p>
    <p>{`You live and die by your monitoring metrics and alarms.`}</p>
    <p>{`Site goes down on Black Friday it's your fault we're losing millions per minute.`}</p>
    <p><img parentName="p" {...{
        "src": "/8ce99ba22f17d162d891e8d197302dfa/media-13YroVUrUrLCec-giphy-downsized-medium.gif",
        "alt": "gulp giphy"
      }}></img></p>
    <p>{`I don't know anybody who `}<em parentName="p">{`likes`}</em>{` doing DevOps. But being an SRE – site reliability engineer – is `}<em parentName="p">{`the`}</em>{` highest paid position in software engineering right now.`}</p>
    <h2 {...{
      "id": "the-future"
    }}>{`The future`}</h2>
    <p>{`The future is bright my friend.`}</p>
    <p>{`With the rise of platforms like Netlify, Vercel, and Begin doing your DevOps, and serverless computing dealing with the repetitive backend work, `}<em parentName="p">{`you`}</em>{` can focus on the business logic.`}</p>
    <p>{`Let AWS deal with servers. Let X deal with hosting. Let junior developers deal with fun UI challenges.`}</p>
    <p><strong parentName="p">{`You focus on Frontend Infrastructure, the Backend of the Frontend. The money maker.`}</strong></p>
    <p>{`And hey with serverless, `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`writing server code is like the JavaScript work you know and love`}</a>{`.`}</p>
    <p>{`It's a JavaScript function. Platform handles the rest. ✌️`}</p>
    <h2 {...{
      "id": "what-did-i-tell-the-head-of-engineering"
    }}>{`What did I tell the head of engineering?`}</h2>
    <p>{`That's the wrong question. Ask them an app architecture question. Like you're interviewing an iOS developer.`}</p>
    <p>{`Our Express "backend" is frontend even if runs on the server.`}</p>
    <p><img parentName="p" {...{
        "src": "/8939e4fc04b35c2173741bcf98edb3e4/media-d3mlE7uhX8KFgEmY-giphy.gif",
        "alt": "think giphy"
      }}></img></p>
    <p>{`Happy Friday ❤️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1291495546557931520"
      }}>{`79% votes for "this is frontend", 20% for "backend"`}</a>{` ✌️`}</p>
    <p>{`PPS: all of the above is why I created `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev/"
      }}>{`Serverless Handbook – modern backend for frontend engineers`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      